/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../styles/variables';
import AccessibleSVG, { SVGProps } from '../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const ChangeOrder56 = (props: SVGProps) => (
    <AccessibleSVG width={56} height={56} viewBox="0 0 56 56" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill={vars.bdlBoxBlue10}
                d="M10 32a6 6 0 110 12 6 6 0 010-12zm38-12c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4z"
            />
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M46 8H10a4 4 0 00-.2 7.995L10 16h36a4 4 0 00.2-7.995L46 8z"
            />
            <path
                fill={vars.bdlBoxBlue}
                fillRule="nonzero"
                d="M46 6a6 6 0 110 12H10a6 6 0 110-12h36zm0 2H10a4 4 0 00-.2 7.995L10 16h36a4 4 0 00.2-7.995L46 8z"
            />
            <path
                fill={vars.bdlBoxBlue}
                d="M46 11a1 1 0 010 2h-1v28h3c1.054 0 1.918.816 1.995 1.85L50 43v2.5a4.5 4.5 0 01-4.288 4.495L45.5 50H15v-.029l-.128-.014a4.502 4.502 0 01-3.867-4.245L11 45.5V13h-1a1 1 0 010-2h36zm-3 2H13v32.5a2.5 2.5 0 004.995.164L18 45.5V43c0-1.054.816-1.918 1.85-1.995L20 41h23V13zm5 30H20v2.5c0 .83-.225 1.609-.618 2.277l-.141.223H45.5a2.501 2.501 0 002.495-2.336L48 45.5V43z"
            />
            <path
                fill={vars.white}
                fillRule="nonzero"
                d="M13 45.5a2.5 2.5 0 004.995.164L18 45.5V43c0-1.054.816-1.918 1.85-1.995L20 41h23V13H13v32.5z"
            />
            <path
                fill={vars.bdlBoxBlue10}
                fillRule="nonzero"
                d="M48 45.5V43H20v2.5c0 .83-.225 1.609-.618 2.277l-.141.223H45.5a2.501 2.501 0 002.495-2.336L48 45.5z"
            />
            <g transform="translate(17 20)">
                <path fill={vars.bdlBoxBlue10} fillRule="nonzero" d="M3 10a2 2 0 10-.001 3.999A2 2 0 003 10z" />
                <path
                    fill={vars.bdlBoxBlue}
                    fillRule="nonzero"
                    d="M3 9a3 3 0 110 6 3 3 0 010-6zm0 1a2 2 0 10-.001 3.999A2 2 0 003 10z"
                />
                <path fill={vars.bdlBoxBlue10} fillRule="nonzero" d="M11 10a2 2 0 10-.001 3.999A2 2 0 0011 10z" />
                <path
                    fill={vars.bdlBoxBlue}
                    fillRule="nonzero"
                    d="M11 9a3 3 0 110 6 3 3 0 010-6zm0 1a2 2 0 10-.001 3.999A2 2 0 0011 10z"
                />
                <rect width={6} height={6} x={16} y={9} fill={vars.bdlBoxBlue} rx={3} />
                <path
                    fill={vars.bdlBoxBlue}
                    fillRule="nonzero"
                    d="M11 0c3.798 0 6.713 2.186 7.964 5.314a.5.5 0 11-.928.372C16.93 2.92 14.369 1 11 1 7.918 1 5.511 2.608 4.277 5H7.5a.5.5 0 01.492.41L8 5.5a.5.5 0 01-.41.492L7.5 6H3.49a.483.483 0 01-.144-.024l-.025-.009-.007-.003-.038-.017-.034-.018.072.035a.504.504 0 01-.114-.063l-.029-.024-.032-.03-.028-.032-.034-.048-.012-.02a.385.385 0 01-.024-.05l-.013-.03c-.006-.017-.01-.035-.015-.052l-.005-.025A.602.602 0 013 5.525V1.5a.5.5 0 01.992-.09L4 1.5v2.032C5.51 1.387 7.975 0 11 0z"
                />
            </g>
        </g>
    </AccessibleSVG>
);

export default ChangeOrder56;
